const invoiceComponentLoaders = Object.freeze({
  'invoicing.invoice-workspace': async () => {
    const module = await import('./invoice-workspace-component.js');
    return module.InvoiceWorkspaceComponent;
  },
});

export default invoiceComponentLoaders;
